module.exports = __webpack_public_path__ + "static/img/product2.968ceb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/white/product2.png
// module id = XL/8
// module chunks = 0